import React from "react";
import { MonthsAbr } from "./dateConstants";
import { getDaysInMonth } from "../getDaysInMonth";

type DateSelectProps = {
  value: {
    year: number;
    computerMonth: number;
    day: number;
  };
  onChange: (arg: { year: number; computerMonth: number; day: number }) => void;
};

const DateSelect: React.FC<DateSelectProps> = ({ value, onChange }) => {
  const { computerMonth, day, year } = value;

  const yearChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedYear = parseInt(e.target.value);
    const days = getDaysInMonth(new Date(selectedYear, computerMonth, 1));

    onChange({
      year: selectedYear,
      computerMonth,
      day: day > days ? days : day,
    });
  };

  const monthChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedMonth = parseInt(e.target.value);
    const days = getDaysInMonth(new Date(year, selectedMonth, 1));

    onChange({
      year,
      computerMonth: selectedMonth,
      day: day > days ? days : day,
    });
  };

  const dayChange = (e: React.ChangeEvent<HTMLSelectElement>) =>
    onChange({
      year,
      computerMonth,
      day: parseInt(e.target.value),
    });

  return (
    <>
      <select
        value={year}
        onChange={yearChange}
        className="mr-2 p-2 rounded-md border border-gray-400 outline-none focus:outline-none"
      >
        {new Array(2).fill(0).map((_, i) => (
          <option key={i} value={new Date().getFullYear() - i}>
            {new Date().getFullYear() - i}
          </option>
        ))}
      </select>
      <select
        onChange={monthChange}
        value={computerMonth}
        className="mr-2 p-2 rounded-md border border-gray-400 outline-none focus:outline-none"
      >
        {MonthsAbr.map((ma, i) => (
          <option key={ma} value={i}>
            {ma}
          </option>
        ))}
      </select>
      <select
        value={day}
        onChange={dayChange}
        className="mr-8 p-2 rounded-md border border-gray-400 outline-none focus:outline-none"
      >
        {new Array(getDaysInMonth(new Date(year, computerMonth, 1)))
          .fill(0)
          .map((_, i) => {
            return (
              <option key={i + 1} value={i + 1}>
                {i + 1}
              </option>
            );
          })}
      </select>
    </>
  );
};

export default DateSelect;
